/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Enable_Confirm_ExceptionsInputs */



/**
* | output |
* | --- |
* | "Project admins, and members you allow to see everyone's chats, still see everything — other members' chats read-only." |
*
* @param {Project_Private_Chats_Enable_Confirm_ExceptionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_enable_confirm_exceptions = /** @type {((inputs?: Project_Private_Chats_Enable_Confirm_ExceptionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Enable_Confirm_ExceptionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt-Admins und Mitglieder, denen Sie es erlauben, die Chats aller Mitglieder zu sehen, sehen weiterhin alles – die Chats anderer Mitglieder nur lesend.")
	return /** @type {LocalizedString} */ ("Project admins, and members you allow to see everyone's chats, still see everything — other members' chats read-only.")
});